import React from "react"
import { Link } from "react-router-dom"
import Grid from "@mui/material/Grid"

import Section from "../template-parts/product-marketing/Section"
import Review from "../template-parts/reviews/ReviewV3"
import { NUM_REVIEWS } from "../../config"

const btwReviews = [
  {
    text: "I wish I could give more stars. He was on time, very professional, yet with a wonderful sense of humor which made my learning alot fun and easy.",
    name: "Philomena",
    location: "Oakland",
    rating: 5,
  },
  {
    text: "As a mom, I am thrilled that my son is working with a qualified instructor that is teaching him to be a safe confident driver.",
    name: "Catherine",
    location: "Los Gatos",
    rating: 5,
  },
  {
    text: "Very patient and easy to understand. Made my driving experience much easier and less scary knowing I had an amazing teacher to guide me.",
    name: "Hailey",
    location: "Morgan Hill",
    rating: 5,
  },
  {
    text: "My instructor was so easy to drive with and he made me feel so safe and capable!",
    name: "Jahanavi",
    location: "San Francisco",
    rating: 5,
  },
]

const Reviews = () => (
  <Section
    head={`Over ${NUM_REVIEWS} 5-Star Reviews`}
    className="section-highlight"
  >
    <Grid container spacing={3} style={{ marginTop: 10 }}>
      {btwReviews.map((review) => (
        <Grid item xs={12} sm={6} md={3} key={review.name}>
          <Review
            text={review.text}
            name={review.name}
            location={review.location}
            rating={review.rating}
          />
        </Grid>
      ))}
    </Grid>
    <Link
      style={{
        display: "block",
        marginTop: 30,
        textAlign: "center",
        color: "#fff",
      }}
      to="/coastline-academy-driving-school-reviews"
    >
      Click here to read more Coastline reviews.
    </Link>
  </Section>
)

export default Reviews
